<template>
  <div class="language-switcher">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          text
          v-bind="attrs"
          v-on="on"
        >
          {{ currentLocale.toUpperCase() }}
          <v-icon small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(lang, i) in availableLocales"
          :key="i"
          @click="changeLocale(lang)"
        >
          <v-list-item-title>{{ lang.toUpperCase() }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      availableLocales: ['en', 'es', 'cat']
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    }
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}
</style>
